const escapeHtml = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const escapeAttr = (s) => escapeHtml(s).replace(/"/g, '&quot;');

const wrapRun = (run) => {
    let out = escapeHtml(run.text);
    if (run.strike) out = `<s>${out}</s>`;
    if (run.underline) out = `<u>${out}</u>`;
    if (run.italic) out = `<em>${out}</em>`;
    if (run.bold) out = `<strong>${out}</strong>`;
    if (run.href) out = `<a href="${escapeAttr(run.href)}">${out}</a>`;
    return out;
};

const LIST_TAG = { bullet: 'ul', numbered: 'ol' };

export const serializeBlocks = (blocks) => {
    let out = '';
    let openList = null; // 'bullet' | 'numbered' | null
    for (const block of blocks) {
        const inline = block.runs.map(wrapRun).join('');
        if (block.type === 'paragraph') {
            if (openList) { out += `</${LIST_TAG[openList]}>`; openList = null; }
            out += `<p>${inline}</p>`;
        } else {
            if (openList && openList !== block.type) { out += `</${LIST_TAG[openList]}>`; openList = null; }
            if (!openList) { out += `<${LIST_TAG[block.type]}>`; openList = block.type; }
            out += `<li>${inline}</li>`;
        }
    }
    if (openList) out += `</${LIST_TAG[openList]}>`;
    return out;
};
